import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import './RI2020WithholdingDisclosureModal.scss';
import Button from '../Button/Button';
import { moduleActions } from '../../../redux/modules';
import { RI2020_WITHHOLDING_DISCLOSURE_MODAL } from '../../../redux/modules/modals/modals.module';
import ExchangeWithholdings from '../../Exchange/ExchangeWithholdings/ExchangeWithholdings';

const RI2020WithholdingDisclosureModal = ({ actions: { closeModal } }) => (
  <div className="RI2020-withholding-container">
    <ExchangeWithholdings disableCheckbox={true} />
    <Button
      buttonType="primary"
      className="btn-trp-primary RI2020-continue-button"
      id="ri2020-income-tax-withholding-disclosure"
      onClick={() => closeModal(RI2020_WITHHOLDING_DISCLOSURE_MODAL)}
    >
      Continue
    </Button>
  </div>
);

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  RI2020WithholdingDisclosureModal
);
